import { render, staticRenderFns } from "./NpsLegend.vue?vue&type=template&id=41779f59&scoped=true&"
import script from "./NpsLegend.vue?vue&type=script&lang=js&"
export * from "./NpsLegend.vue?vue&type=script&lang=js&"
import style0 from "./NpsLegend.vue?vue&type=style&index=0&id=41779f59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41779f59",
  null
  
)

export default component.exports